<panel width="200">
  <list-view [selectable]="false">
    <header>{{ 'ledger-posts-comparison.column.dates' | translate }}</header>
    <row *listData="let state from historicalStates" [highlighted]="selectedStates.indexOf(state) >= 0" (click)="selectState(state);">
      <column [sortValue]="state.endTimestamp">
      @if (state.endTimestamp) {
        {{ state.endTimestamp | customDate: 'fullDateTime' }}
      }
      @if (!state.endTimestamp) {
        {{ 'ledger-posts-comparison.current-billing-plan' | translate }}
      }
    </column>
  </row>
</list-view>
</panel>
@if (selectedStates.length === 0) {
  <panel>
  </panel>
}
@for (state of selectedStates; track state) {
  <panel>
    @if (state.endTimestamp) {
      <h1>{{  'ledger-posts-comparison.state-before-timestamp' | translate: { timestamp: state.endTimestamp | customDate: 'fullDateTime' } }}</h1>
    }
    @if (!state.endTimestamp) {
      <h1>{{ 'ledger-posts-comparison.current-billing-plan' | translate }}</h1>
    }
    <ledger-posts [historicalDate]="state.endTimestamp" [productPlans]="productPlans" [accountingPlan]="accountingPlan" [displayProductName]="false" />
  </panel>
}
